<template>
	<div>
		<header class="page-title">
			<h2>Articles</h2>
			<div class="ml-auto">
				<a v-if="userRoles.includes('site_settings.update')" href="#" class="btn btn-md btn-success" @click="saveSettings"><i class="fas fa-save"></i> Save Changes</a>
			</div>
		</header>
		<div class="card">
			<header class="card-header">
				<h4 class="card-title">Beginner's privacy guides</h4>
			</header>
			<div class="card-body">
				<h4 class="card-subtitle">Main Article</h4>
				<table class="mb-2">
					<thead>
						<tr>
							<th>Position</th>
							<th>Article</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>1</td>
							<td>
								<select3 :value.sync="settings.main_article.value" :data="articles" :config="selectConfig"></select3>
							</td>
						</tr>
					</tbody>
				</table>
				<h4 class="card-subtitle">Top 4 Articles</h4>
				<table>
					<thead>
						<tr>
							<th>Position</th>
							<th>Article</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(row, key) in settings.top_four">
							<td>{{ key }}.</td>
							<td>
								<select3 :value.sync="row.value" :data="articles" :config="selectConfig"></select3>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div class="card">
			<header class="card-header">
				<h4 class="card-title">Advanced privacy guides</h4>
			</header>
			<div class="card-body">
				<h4 class="card-subtitle">Main Article</h4>
				<table class="mb-2">
					<thead>
						<tr>
							<th>Position</th>
							<th>Article</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>1</td>
							<td>
								<select3 :value.sync="settings.advanced_main_article.value" :data="articles" :config="selectConfig"></select3>
							</td>
						</tr>
					</tbody>
				</table>
				<h4 class="card-subtitle">Top 4 Articles</h4>
				<table>
					<thead>
						<tr>
							<th>Position</th>
							<th>Article</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(row, key) in settings.advanced_top_four">
							<td>{{ key }}.</td>
							<td>
								<select3 :value.sync="row.value" :data="articles" :config="selectConfig"></select3>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div class="card">
			<header class="card-header">
				<h4 class="card-title">Comparisons</h4>
			</header>
			<div class="card-body">
				<h4 class="card-subtitle">Main Article</h4>
				<table class="mb-2">
					<thead>
						<tr>
							<th>Position</th>
							<th>Article</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>1</td>
							<td>
								<select3 :value.sync="settings.hubs_main.value" :data="articles" :config="selectConfig"></select3>
							</td>
						</tr>
					</tbody>
				</table>
				<h4 class="card-subtitle">Top 4 Articles</h4>
				<table>
					<thead>
						<tr>
							<th>Position</th>
							<th>Article</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(row, key) in settings.hubs_top_four">
							<td>{{ key }}.</td>
							<td>
								<select3 :value.sync="row.value" :data="articles" :config="selectConfig"></select3>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div class="card">
			<header class="card-header">
				<h4 class="card-title">Privacy Tools</h4>
			</header>
			<div class="card-body">
				<h4 class="card-subtitle">Main Article</h4>
				<table class="mb-2">
					<thead>
					<tr>
						<th>Position</th>
						<th>Article</th>
					</tr>
					</thead>
					<tbody>
					<tr>
						<td>1</td>
						<td>
							<select3 :value.sync="settings.our_tools_main.value" :data="articles" :config="selectConfig"></select3>
						</td>
					</tr>
					</tbody>
				</table>
				<h4 class="card-subtitle">Top 4 Articles</h4>
				<table>
					<thead>
					<tr>
						<th>Position</th>
						<th>Article</th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="(row, key) in settings.our_tools_top_four">
						<td>{{ key }}.</td>
						<td>
							<select3 :value.sync="row.value" :data="articles" :config="selectConfig"></select3>
						</td>
					</tr>
					</tbody>
				</table>
			</div>
		</div>

		<loader></loader>
	</div>
</template>

<script>
import VueSelect from '../../../../node_modules/vue-select';
import {eventBus} from "../../app";

export default {
	components: {
		VueSelect
	},
	data: function () {
		return {
			userRoles: this.$currentUserRoles,
			articles: [],
			hubs: [],
			tools: [],
			selectConfig: {
				keyName: 'id',
				valueName: 'title',
				originalValue: true
			},
			settings: {
				main_article: {
					group: 'home_page',
					subGroup: 'guides_and_articles',
					key: 'main_article',
					order: 1,
					value: 0
				},
				top_four: {
					1: {
						group: 'home_page',
						subGroup: 'guides_and_articles',
						key: 'top_four',
						order: 1,
						value: 0
					},
					2: {
						group: 'home_page',
						subGroup: 'guides_and_articles',
						key: 'top_four',
						order: 2,
						value: 0
					},
					3: {
						group: 'home_page',
						subGroup: 'guides_and_articles',
						key: 'top_four',
						order: 3,
						value: 0
					},
					4: {
						group: 'home_page',
						subGroup: 'guides_and_articles',
						key: 'top_four',
						order: 4,
						value: 0
					}
				},
				advanced_main_article: {
					group: 'home_page',
					subGroup: 'guides_and_articles',
					key: 'advanced_main_article',
					order: 1,
					value: 0
				},
				advanced_top_four: {
					1: {
						group: 'home_page',
						subGroup: 'guides_and_articles',
						key: 'advanced_top_four',
						order: 1,
						value: 0
					},
					2: {
						group: 'home_page',
						subGroup: 'guides_and_articles',
						key: 'advanced_top_four',
						order: 2,
						value: 0
					},
					3: {
						group: 'home_page',
						subGroup: 'guides_and_articles',
						key: 'advanced_top_four',
						order: 3,
						value: 0
					},
					4: {
						group: 'home_page',
						subGroup: 'guides_and_articles',
						key: 'advanced_top_four',
						order: 4,
						value: 0
					}
				},
				hubs_main: {
					group: 'home_page',
					subGroup: 'guides_and_articles',
					key: 'hubs_main',
					order: 1,
					value: 0
				},
				hubs_top_four: {
					1: {
						group: 'home_page',
						subGroup: 'guides_and_articles',
						key: 'hubs_top_four',
						order: 1,
						value: 0
					},
					2: {
						group: 'home_page',
						subGroup: 'guides_and_articles',
						key: 'hubs_top_four',
						order: 2,
						value: 0
					},
					3: {
						group: 'home_page',
						subGroup: 'guides_and_articles',
						key: 'hubs_top_four',
						order: 3,
						value: 0
					},
					4: {
						group: 'home_page',
						subGroup: 'guides_and_articles',
						key: 'hubs_top_four',
						order: 4,
						value: 0
					}
				},
				our_tools_main: {
					group: 'home_page',
					subGroup: 'guides_and_articles',
					key: 'our_tools_main',
					order: 1,
					value: 0
				},
				our_tools_top_four: {
					1: {
						group: 'home_page',
						subGroup: 'guides_and_articles',
						key: 'our_tools_top_four',
						order: 1,
						value: 0
					},
					2: {
						group: 'home_page',
						subGroup: 'guides_and_articles',
						key: 'our_tools_top_four',
						order: 2,
						value: 0
					},
					3: {
						group: 'home_page',
						subGroup: 'guides_and_articles',
						key: 'our_tools_top_four',
						order: 3,
						value: 0
					},
					4: {
						group: 'home_page',
						subGroup: 'guides_and_articles',
						key: 'our_tools_top_four',
						order: 4,
						value: 0
					}
				}
			}
		}
	},
	mounted() {
		let vm = this;
		vm.getSettings()
	},
	methods: {
		getSettings: function () {
			eventBus.$emit('onLoaderStart');
			let vm = this;
			axios.get('/api/' + vm.$selectedSite.slug + '/settings/home_page')
					.then(response => {
						vm.parseData(response.data);
						vm.$toastr.success('General data loaded successfully', 'Success');
					})
					.catch(e => {
						eventBus.$emit('onLoaderFinish');
						this.$toastr.error('General data load failed.', 'Error');
					});
		},
		saveSettings: function () {
			eventBus.$emit('onLoaderStart');
			let vm = this;

			axios.post('/api/' + vm.$selectedSite.slug + '/settings', vm.settings)
					.then(response => {
						eventBus.$emit('onLoaderFinish');
						vm.$toastr.success('General data saved successfully', 'Success');
					})
					.catch(e => {
						eventBus.$emit('onLoaderFinish');
						this.$toastr.error('General data save failed.', 'Error');
					});
		},
		parseData: function (data) {
			let vm = this;
			vm.articles = data.choices;

			let main_article = data.siteSettings.find(element => element.key === 'main_article');
			if (main_article) {
				vm.settings.main_article = main_article;
				vm.settings.main_article.value = vm.articles.find(article => article.id === parseInt(main_article.value) && article.type === main_article.type);
			}
			for (let i = 1; i < 5; i++) {
				let top_four = data.siteSettings.find(element => element.key === 'top_four' && element.order === i);
				if (top_four) {
					vm.settings.top_four[i] = top_four;
					vm.settings.top_four[i].value = vm.articles.find(article => article.id === parseInt(top_four.value) && article.type === top_four.type);
				}
			}

			let advanced_main_article = data.siteSettings.find(element => element.key === 'advanced_main_article');
			if (advanced_main_article) {
				vm.settings.advanced_main_article = advanced_main_article;
				vm.settings.advanced_main_article.value = vm.articles.find(article => article.id === parseInt(advanced_main_article.value) && article.type === advanced_main_article.type);
			}
			for (let i = 1; i < 5; i++) {
				let top_four = data.siteSettings.find(element => element.key === 'advanced_top_four' && element.order === i);
				if (top_four) {
					vm.settings.advanced_top_four[i] = top_four;
					vm.settings.advanced_top_four[i].value = vm.articles.find(article => article.id === parseInt(top_four.value) && article.type === top_four.type);
				}
			}

			let our_tools_main = data.siteSettings.find(element => element.key === 'our_tools_main');
			if (our_tools_main) {
				vm.settings.our_tools_main = our_tools_main;
				vm.settings.our_tools_main.value = vm.articles.find(article => article.id === parseInt(our_tools_main.value) && article.type === our_tools_main.type);
			}
			for (let i = 1; i < 5; i++) {
				let top_four = data.siteSettings.find(element => element.key === 'our_tools_top_four' && element.order === i);
				if (top_four) {
					vm.settings.our_tools_top_four[i] = top_four;
					vm.settings.our_tools_top_four[i].value = vm.articles.find(article => article.id === parseInt(top_four.value) && article.type === top_four.type);
				}
			}

			let hubs_main = data.siteSettings.find(element => element.key === 'hubs_main');
			if (hubs_main) {
				vm.settings.hubs_main = hubs_main;
				vm.settings.hubs_main.value = vm.articles.find(article => article.id === parseInt(hubs_main.value) && article.type === hubs_main.type);
			}
			for (let i = 1; i < 5; i++) {
				let hubs_top_four = data.siteSettings.find(element => element.key === 'hubs_top_four' && element.order === i);
				if (hubs_top_four) {
					vm.settings.hubs_top_four[i] = hubs_top_four;
					vm.settings.hubs_top_four[i].value = vm.articles.find(article => article.id === parseInt(hubs_top_four.value) && article.type === hubs_top_four.type);
				}
			}

			eventBus.$emit('onLoaderFinish');
		}
	}
}
</script>

<style scoped>

</style>
